var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    fillRule: "evenodd",
    d: "M3.333 4.167A.84.84 0 0 0 2.5 5v10c0 .456.377.833.833.833h13.334A.84.84 0 0 0 17.5 15V5a.84.84 0 0 0-.833-.833zM.833 5c0-1.377 1.123-2.5 2.5-2.5h13.334c1.377 0 2.5 1.123 2.5 2.5v10c0 1.377-1.123 2.5-2.5 2.5H3.333a2.505 2.505 0 0 1-2.5-2.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    fillRule: "evenodd",
    d: "M.984 4.522a.833.833 0 0 1 1.16-.205L10 9.817l7.855-5.5a.833.833 0 0 1 .956 1.366l-8.333 5.833c-.287.2-.669.2-.956 0L1.19 5.683a.833.833 0 0 1-.205-1.16Z",
    clipRule: "evenodd"
  })));
};
export default SvgMail;